import React from "react";

const EditPencilIcon = ({ closeButton = false, className = "" }) => {
  const color = closeButton ? "#1D4469" : "currentColor";

  return (
    <svg
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4819 8.31079L6.54917 15.244C6.51429 15.279 6.4891 15.3231 6.47711 15.3706L5.70869 18.4549C5.6857 18.5477 5.71298 18.6465 5.78074 18.7142C5.83201 18.7655 5.90187 18.7939 5.97332 18.7939C5.99521 18.7939 6.0176 18.7912 6.03938 18.7857L9.12367 18.0172C9.17174 18.0052 9.21541 17.9801 9.25029 17.9452L16.1836 11.0125L13.4819 8.31079Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
      <path
        d="M17.8994 7.3654L17.1277 6.59368C16.6119 6.0779 15.7129 6.0784 15.1978 6.59368L14.2524 7.53899L16.9541 10.2406L17.8994 9.2953C18.157 9.03776 18.2989 8.69498 18.2989 8.3304C18.2989 7.96583 18.157 7.62304 17.8994 7.3654Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default EditPencilIcon;
